import React, {useCallback} from 'react';
import {useDropzone} from 'react-dropzone';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import UploadIcon from '@material-ui/icons/CloudUpload';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  root: {
    padding: '1rem 0',
    width: '100%',
  },
  dropZone: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '5rem',
    border: `2px dashed ${theme.palette.common.tealish}`,
    alignSelf: 'center',
    padding: '1rem',
    cursor: 'pointer',
    '&:hover': {
      border: `2px solid ${theme.palette.common.tealish}`,
    },
    '&:focus': {
      border: `2px solid ${theme.palette.common.tealish}`,
      outline: 'none',
    },
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  icon: {
    width: 50,
    height: 50,
    color: theme.palette.common.tealish,
    marginRight: '1rem',
  },
}));

const FileDropZone = ({addFiles}) => {
  const classes = useStyles();

  const onDrop = useCallback(async files => {
    if (files.length < 1) return;  // rejected drop, eg unsupported file type
    addFiles(files);
  }, [addFiles]);

  const {getRootProps, getInputProps} = useDropzone({onDrop});

  return (
    <div className={classes.root}>
      <div {...getRootProps()} className={classes.dropZone}>
        <input {...getInputProps()} />
        <UploadIcon className={classes.icon} />
        <Typography variant="subtitle2">
          Drag &apos;n&apos; drop your documents here, or click to select from your PC&apos;s drives.
        </Typography>
      </div>
    </div>
  );
};

FileDropZone.propTypes = {
  addFiles: PropTypes.func.isRequired,
};

export default FileDropZone;
